import { Dialog, DialogContent, DialogTitle } from "@/components/ui/dialog";

export const FormDialog = ({ open, onOpenChange, title, onSubmit, busy, children, testid }) => (
  <Dialog open={open} onOpenChange={onOpenChange}>
    <DialogContent data-testid={testid} className="bg-[#f4efe2] border-2 border-[#c9a227] rounded-none max-w-2xl max-h-[90vh] overflow-y-auto">
      <DialogTitle className="font-display text-2xl">{title}</DialogTitle>
      <form onSubmit={(e) => { e.preventDefault(); onSubmit(); }} className="grid gap-4">
        {children}
        <div className="flex justify-end gap-3 pt-2">
          <button type="button" onClick={() => onOpenChange(false)} className="btn-ghost-illum">Cancel</button>
          <button type="submit" disabled={busy} data-testid={`${testid}-save`} className="btn-illum theme-flame disabled:opacity-60">{busy ? "Saving…" : "Save"}</button>
        </div>
      </form>
    </DialogContent>
  </Dialog>
);

export const Field = ({ label, children }) => (
  <div><label className="admin-label">{label}</label>{children}</div>
);
